export default [
    {
        path: '/car',
        meta: {
            title: "Car Management",
            show: true
        },
        component: () => import(/* webpackChunkName: "car" */ '../views/admin/page/CarManagement/Index'),
        redirect: { name: 'car.etoll' },
        children: [
            {
                path: 'etoll',
                name: 'car.etoll',
                meta: {
                    title: "E Toll",
                    show: true
                },
                component: () => import(/* webpackChunkName: "car" */ '../views/admin/page/CarManagement/EToll'),
            },
            {
                path: 'transactionform',
                name: 'car.transactionform',
                meta: {
                    title: "E Toll Form Transaction",
                    show: true
                },
                component: () => import(/* webpackChunkName: "car" */ '../views/admin/page/CarManagement/ETollTransactionForm'),
            },
        ]
    }
]